import apiClient from "../apiClient";
import { STAYS_ENDPOINTS } from "../endpoints/stays";

export const fetchStaysHome = async (params) => {
  try {
    const response = await apiClient.get(STAYS_ENDPOINTS.home, { params });
    return response.data;
  } catch (error) {
    console.error("Error fetching stays home:", error);
    throw error;
  }
};

export const searchStays = async (payload = {}) => {
  try {
    const response = await apiClient.post(STAYS_ENDPOINTS.search, payload);
    return response.data;
  } catch (error) {
    console.error("Error searching stays:", error);
    throw error;
  }
};

export const fetchHotels = async (params) => {
  try {
    const response = await apiClient.get(STAYS_ENDPOINTS.hotels, { params });
    return response.data;
  } catch (error) {
    console.error("Error fetching hotels:", error);
    throw error;
  }
};

export const fetchHotelById = async (id) => {
  try {
    const response = await apiClient.get(STAYS_ENDPOINTS.hotelById, {
      params: { id },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching hotel:", error);
    throw error;
  }
};

export const fetchHotelBrands = async (params) => {
  try {
    const response = await apiClient.get(STAYS_ENDPOINTS.brands, { params });
    return response.data;
  } catch (error) {
    console.error("Error fetching hotel brands:", error);
    throw error;
  }
};

export const fetchStayCities = async (params) => {
  try {
    const response = await apiClient.get(STAYS_ENDPOINTS.cities, { params });
    return response.data;
  } catch (error) {
    console.error("Error fetching stay cities:", error);
    throw error;
  }
};
